export default __webpack_public_path__ + "static/media/android-developer.9f0191f4.jpg";